var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('artifacts',{attrs:{"from":"interviewReports"},scopedSlots:_vm._u([{key:"artifact",fn:function(ref){
var artifact = ref.artifact;
var store = ref.store;
return [_c('InterviewReport',{attrs:{"interviewer":_vm.interviewer,"interviewee":_vm.interviewee,"value":artifact},on:{"change":function($event){return store(artifact)}}})]}},{key:"ifNotFound",fn:function(ref){
var store = ref.store;
return [_c('InterviewReport',{attrs:{"interviewer":_vm.interviewer,"interviewee":_vm.interviewee,"value":{},"defaults":_vm.defaults},on:{"change":function($event){return store($event)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }